import { render } from "./Blog.vue?vue&type=template&id=2c3914d8"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=2c3914d8&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__